import React from 'react'
import { Notification } from './components/Notification'
import { useNotification } from './context/NotificationContext'
import AppRoute from './routes/AppRoute'

export default function App (): JSX.Element {
  const { notification: { message, type, messageId } } = useNotification()
  return (
    <React.Fragment>
      <AppRoute />
      <Notification key={messageId} message={message} type={type} />
    </React.Fragment>
  )
}
